<template>
  <div>
    <el-form
      size="mini"
      :rules="rules"
      ref="form"
      :model="formData"
      :disabled="disabled"
      label-position="top"
    >
      <div class="side-frame">
        <span class="side-frame-text">
          {{ $l('form_label_fabric_info_text') || '面料信息' }}
        </span>
      </div>

      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_fabricNo') || '物料编码'"
            prop="fabricNo"
          >
            <el-input
              v-model="formData.fabricNo"
              :disabled="!!inspectionCode"
              readonly
            >
              <el-button
                v-if="!inspectionCode"
                slot="append"
                icon="el-icon-more"
                @click="openChooseFabric"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_fabricName') || '物料名称'">
            <el-input
              clearable
              v-model="formData.fabricName"
              size="mini"
              readonly
              disabled
              style="width: 100%"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_fabricWidth') || '门幅'">
            <el-input
              clearable
              v-model="formData.v_fabricWidth"
              size="mini"
              readonly
              disabled
              style="width: 100%"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_fabricWeight') || '克重'">
            <el-input
              clearable
              v-model="formData.v_fabricWeight"
              size="mini"
              readonly
              disabled
              style="width: 100%"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_fabricColor') || '颜色'">
            <el-input
              clearable
              v-model="formData.fabricColor"
              size="mini"
              readonly
              disabled
              style="width: 100%"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_fabricContent') || '规格型号'"
            prop="fabricContent"
          >
            <el-input
              clearable
              v-model="formData.fabricContent"
              size="mini"
              readonly
              disabled
              style="width: 100%"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_series') || '系列'"
            prop="series"
          >
            <el-input
              clearable
              v-model="formData.series"
              size="mini"
              readonly
              disabled
              style="width: 100%"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_purchaseFabricNo') || '采购单号'"
          >
            <el-input
              clearable
              v-model="formData.purchaseFabricNo"
              size="mini"
              readonly
              disabled
              style="width: 100%"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_originOrderNo') || '源头订单号'">
            <el-input
              clearable
              v-model="formData.originOrderNo"
              size="mini"
              readonly
              disabled
              style="width: 100%"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_buyerName') || '采购人员'"
            prop="buyerName"
          >
            <el-input
              clearable
              v-model="formData.buyerName"
              size="mini"
              readonly
              disabled
              style="width: 100%"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_scmName') || '供方'"
            prop="scmName"
          >
            <el-input
              clearable
              v-model="formData.scmName"
              size="mini"
              readonly
              disabled
              style="width: 100%"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_purchaserEntity') || '需方'"
            prop="purchaserEntityName"
          >
            <el-input
              clearable
              v-model="formData.purchaserEntityName"
              size="mini"
              readonly
              disabled
              style="width: 100%"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="side-frame">
        <span class="side-frame-text">
          {{ $l('form_label_register_text') || '入库登记' }}
        </span>
      </div>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_arrivalDate') || '实际到料日期'"
            prop="arrivalDate"
          >
            <el-date-picker
              v-model="formData.arrivalDate"
              type="date"
              size="mini"
              value-format="yyyy-MM-dd"
              format="yyyy/MM/dd"
              :placeholder="
                $l('form_please_arrivalDate') || '请选择实际到料日期'
              "
              style="width: 100%"
              :picker-options="arrivalDatePicker"
              :disabled="registerDisabled"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_totalArrivalQuantity') || '来料总数量'"
            prop="totalArrivalQuantity"
          >
            <el-input-number
              v-model="formData.totalArrivalQuantity"
              :controls="false"
              style="width:100%"
              :precision="2"
              :max="999999999"
              :min="0.01"
              v-el-inputnumber-default0
              :step="0.01"
              :placeholder="
                $l('form_please_totalArrivalQuantity') || '请输入来料总数量'
              "
              :disabled="registerDisabled"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_totalArrivalRolls') || '来料总匹数'"
            prop="totalArrivalRolls"
          >
            <el-input-number
              v-model="formData.totalArrivalRolls"
              :controls="false"
              style="width:100%"
              :precision="0"
              :max="999999999"
              :min="1"
              v-el-inputnumber-default0
              :step="1"
              :placeholder="
                $l('form_please_totalArrivalRolls') || '请输入来料总匹数'
              "
              :disabled="registerDisabled"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_whReceiverNames') || '仓库收货人员'"
            prop="whReceiverNames"
          >
            <ChooseUser
              v-model="formData.whReceiverNames"
              :placeholder="
                $l('tips_select_whReceiverNames') || '请选择仓库收货人员'
              "
              clearable
              filterable
              multiple
              size="mini"
              :disabled="registerDisabled"
              style="width: 100%"
              @confirm="choosewhConfirm"
            ></ChooseUser>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-if="showInspection">
        <div class="side-frame">
          <span class="side-frame-text">
            {{ $l('form_label_inspection_text') || '入库检验' }}
          </span>
        </div>
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_inspectionDate') || '检验日期'"
              prop="inspectionDate"
            >
              <el-date-picker
                v-model="formData.inspectionDate"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                format="yyyy/MM/dd"
                :placeholder="
                  $l('form_please_inspectionDate') || '请选择检验日期'
                "
                style="width: 100%"
                :picker-options="inspectionDatePicker"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_reporterNames') || '检验人员'"
              prop="reporterNames"
            >
              <ChooseUser
                v-model="formData.reporterNames"
                :placeholder="$l('tips_select_placeholder') || '请选择检验人员'"
                clearable
                filterable
                multiple
                size="mini"
                :disabled="disabled"
                style="width: 100%"
                @confirm="chooseUserConfirm"
              ></ChooseUser>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_totalInspectQuantity') || '检验米数'"
            >
              <el-input
                v-model="formData.totalInspectQuantity"
                type="text"
                readonly
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_totalActualQuantity') || '实测米数'"
            >
              <el-input
                v-model="formData.totalActualQuantity"
                type="text"
                readonly
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_totalQualifiedQuantity') || '合格米数'"
            >
              <el-input
                v-model="formData.totalQualifiedQuantity"
                type="text"
                readonly
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_totalDefectiveQuantity') || '不良米数'"
            >
              <el-input
                v-model="formData.totalDefectiveQuantity"
                type="text"
                readonly
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_inspectionMethod') || '检验方式'"
              prop="inspectionMethod"
            >
              <el-radio-group size="small" v-model="formData.inspectionMethod">
                <el-radio label="PARTIAL">
                  {{ this.$l('form_label_PARTIAL') || '抽检' }}
                </el-radio>
                <el-radio label="ALL">
                  {{ this.$l('form_label_ALL') || '全检' }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_isSampleRetained') || '是否留样'"
              prop="isSampleRetained"
            >
              <el-radio-group size="small" v-model="formData.isSampleRetained">
                <el-radio label="Y">
                  {{ this.$l('form_label_YES') || '是' }}
                </el-radio>
                <el-radio label="N">
                  {{ this.$l('form_label_NO') || '否' }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_totalInspectionRolls') || '检验匹数'"
            >
              <el-input
                v-model="formData.requiredInspectionRolls"
                type="text"
                readonly
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_totalQualifiedRolls') || '合格匹数'"
            >
              <el-input
                v-model="formData.totalQualifiedRolls"
                type="text"
                readonly
                disabled
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_totalDefectiveRolls') || '不良匹数'"
            >
              <el-input
                v-model="formData.totalDefectiveRolls"
                type="text"
                readonly
                disabled
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_totalDefectCount') || '疵点总数'"
            >
              <el-input
                clearable
                v-model="formData.totalDefectCount"
                size="mini"
                readonly
                disabled
                style="width: 100%"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_totalUtilizationRate') || '利用率'"
            >
              <el-input
                clearable
                v-model="formData.v_totalUtilizationRate"
                size="mini"
                readonly
                disabled
                style="width: 100%"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_qualityCostIndex') || '质量成本系数'"
            >
              <el-input
                clearable
                v-model="formData.qualityCostIndex"
                size="mini"
                readonly
                disabled
                style="width: 100%"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_shortQuantity') || '短码数量（米）'"
            >
              <el-input
                clearable
                v-model="formData.totalShortQuantity"
                size="mini"
                readonly
                disabled
                style="width: 100%"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$l('form_label_totalShortRate') || '短码率'">
              <el-input
                clearable
                v-model="formData.v_totalShortRate"
                size="mini"
                readonly
                disabled
                style="width: 100%"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_inspectionResult') || '判定结果'"
            >
              <el-input
                clearable
                v-model="formData.v_inspectionResult"
                size="mini"
                readonly
                disabled
                style="width: 100%"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="
                $l('form_label_totalLetGoQuantity') || '让步接收数量（米）'
              "
            >
              <el-input
                clearable
                v-model="formData.totalLetGoQuantity"
                size="mini"
                readonly
                disabled
                style="width: 100%"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_totalReturnQuantity') || '退货数量（米）'"
            >
              <el-input
                clearable
                v-model="formData.totalReturnQuantity"
                size="mini"
                readonly
                disabled
                style="width: 100%"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_inStockQuantity') || '入库数量（米）'"
            >
              <el-input
                clearable
                v-model="formData.inStockQuantity"
                size="mini"
                readonly
                disabled
                style="width: 100%"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <el-row v-if="showInspection">
      <InspectionTable
        ref="inspectionTable"
        :disabled="disabled"
        :inspectionCode="inspectionCode"
        :tableData="inspectionDetailList"
        :totalArrivalQuantity="formData.totalArrivalQuantity"
        :totalInspectionRolls="formData.totalInspectionRolls"
        @refresh="refresh"
      />
    </el-row>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>

    <ChooseFabricPurchase
      :visible.sync="chooseMaterialVisible"
      confirm-on-close
      reserve
      @confirm="chooseMaterialConfirm"
    >
    </ChooseFabricPurchase>
    <AddReview
      :inspectionCode="inspectionCode"
      :isStop="reviewOpts.isStop"
      @close="refreshDetail"
      :visible.sync="showReview"
    ></AddReview>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import dayjs from '@/libs/util.date'
import validate from '@/libs/util.validate'
import ChooseFabricPurchase from '../choose-fabric-purchase'
import { multiplyUp, add } from '@/libs/util.number.js'
import InspectionTable from './inspection-table'
import ChooseUser from '../choose-user'
import AddReview from '../add-review'
import { mapState } from 'vuex'

export default {
  mixins: [EditLoading],
  components: { InspectionTable, ChooseFabricPurchase, ChooseUser, AddReview },
  props: {
    inspectionCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  watch: {
    inspectionResult: {
      handler(val) {
        if (['Y'].includes(val)) {
          this.formData.rejectHandling = ''
        }
      },
      immediate: true,
    },
    totalInspectionRolls: {
      handler(val) {
        if (!val) return
        this.formData.totalInspectionRolls = val
      },
      immediate: true,
    },
  },
  async mounted() {
    await this.getData()
    await this.getInspectionDetailList()
  },
  data() {
    return {
      backDialogVisible: false,
      chooseMaterialVisible: false,
      visible: false,
      showReview: false,
      reviewOpts: { isStop: false },
      formData: {
        arrivalDate: dayjs(new Date()).format('YYYY-MM-DD'),
        inspectionDate: dayjs(new Date()).format('YYYY-MM-DD'),
      },
      inspectionDetailList: [],
      inspectionResultMap: {
        Y: '合格',
        N: '不合格',
        B: '部分合格',
      },
      arrivalDatePicker: this.arrivalDate(),
      inspectionDatePicker: this.inspectionDate(),
    }
  },
  computed: {
    ...mapState('admin/user', { userInfo: 'info' }),
    status() {
      return this.formData.status || ''
    },
    registerDisabled() {
      return this.status ? this.status != 'N' : false
    },
    auditDisabled() {
      return this.status ? ['R', 'T'].includes(this.status) : false
    },
    showInspection() {
      return this.inspectionCode && this.status != 'N'
    },
    totalArrivalRolls() {
      const { totalArrivalRolls } = this.formData || {}
      return totalArrivalRolls > 3
    },
    totalInspectionRolls() {
      const { totalArrivalRolls } = this.formData || {}
      return totalArrivalRolls > 3
        ? multiplyUp(totalArrivalRolls, 0.2, 0)
        : totalArrivalRolls
    },
    rules() {
      return {
        fabricNo: [
          {
            required: true,
            message: this.$l('form_please_fabricNo') || '请选择物料',
            trigger: ['change', 'blur'],
          },
        ],
        arrivalDate: [
          {
            required: true,
            message: this.$l('form_please_arrivalDate') || '请选择实际到料日期',
            trigger: 'change',
          },
        ],
        inspectionDate: [
          {
            required: true,
            message: this.$l('form_please_inspectionDate') || '请选择检验日期',
            trigger: 'change',
          },
        ],
        totalArrivalQuantity: [
          {
            required: true,
            message:
              this.$l('form_please_totalArrivalQuantity') || '请输入来料总数量',
            trigger: 'blur',
          },
        ],
        totalArrivalRolls: [
          {
            required: true,
            message:
              this.$l('form_please_totalArrivalRolls') || '请输入来料总匹数',
            trigger: 'blur',
          },
        ],
        reporterNames: [
          {
            required: true,
            message: this.$l('form_please_userNameText') || '请选择检验人员',
            trigger: ['blur', 'change'],
          },
        ],
        inspectionMethod: [
          {
            required: true,
            message: this.$l('form_label_pl_inspectionMethod') || '请选择检验方式',
            trigger: 'change',
          },
        ],
        // isSampleRetained: [
        //   {
        //     required: true,
        //     message: this.$l('form_label_pl_isSampleRetained') || '请选择是否留样',
        //     trigger: 'change',
        //   },
        // ],
        whReceiverNames: [
          {
            required: true,
            message:
              this.$l('tips_select_whReceiverNames') || '请选择仓库收货人员',
            trigger: ['blur', 'change'],
          },
        ],
      }
    },
  },
  methods: {
    async getData() {
      if (!this.inspectionCode) {
         if (this.userInfo) this.choosewhConfirm ([{ ...this.userInfo }])
         return
      }
      await this.$api
        .fabricInspectionDetailApi({
          inspectionCode: this.inspectionCode,
        })
        .then((res) => {
          this.formData = res.body || {}
          const { fabricWidth, fabricWidthUnit, inspectionDate } =
            this.formData || {}
          this.formData.v_fabricWidth = [fabricWidth, fabricWidthUnit]
            .filter(Boolean)
            .join(' ')
          const {
            fabricWeight,
            fabricWeightUnit,
            totalUtilizationRate = 0,
            totalShortRate = 0,
          } = this.formData
          this.formData.v_fabricWeight = [fabricWeight, fabricWeightUnit]
            .filter(Boolean)
            .join(' ')
          this.formData.v_totalUtilizationRate = totalUtilizationRate + '%'
          this.formData.v_totalShortRate = totalShortRate + '%'
          this.formData.inspectionDate =
            inspectionDate || dayjs(new Date()).format('YYYY-MM-DD')
          if (!this.formData.reporterNames) {
            if (this.userInfo) this.chooseUserConfirm([{ ...this.userInfo }])
          }
          this.$emit('loadData', { ...res.body })
        })
      this.$refs.form.clearValidate()
    },
    getInspectionDetailList() {
      if (!this.inspectionCode) {
        this.$emit('major-change', false)
        return
      }
      this.$api
        .fabricInspectionDetailListApi({
          inspectionCode: this.inspectionCode,
        })
        .then((res) => {
          this.inspectionDetailList = res.body.data || []
          const hasMajorNonconformity = this.inspectionDetailList.some(
            (item) => {
              const majorProblem = `${item?.majorProblem || ''}`.trim()
              if (!majorProblem) return false
              return ['有'].includes(majorProblem)
            },
          )
          this.$emit('major-change', hasMajorNonconformity)
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      const params = {
        ...this.formData,
      }
      const api =
        this.inspectionCode && this.status != 'N'
          ? this.$api.fabricInspectionSaveApi
          : this.$api.fabricInspectioRegisterApi
      this.loadingOpen()
      api({ ...params })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })

            if (this.inspectionCode) {
              this.getData()
            } else {
              this.$router.replace({
                name: 'quality-fabricInspectionReport-detail',
                params: { code: res.body.inspectionCode, pageType: 'detail' },
                query: { inspectionNo: res.body.inspectionNo },
              })
            }
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    async submitInspection({ inspectionCode }) {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      this.$confirm(
        this.$l('confirm_label_submitInspection') || '是否要提交质检？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        },
      ).then(() => {
        this.loadingOpen()
        this.$api
          .fabricInspectioSubmitInspectionApi({
            ...this.formData,
            inspectionCode,
          })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('tips_submission_successful') || '提交成功！',
              type: 'success',
            })
            this.getData()
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(
              this.$l('tips_submission_failed') || '提交失败！',
            )
          })
      })
    },
    del({ inspectionCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        },
      ).then(() => {
        this.loadingOpen()
        this.$api
          .fabricInspectionDelApi({ inspectionCode })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.close()
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          })
      })
    },
    async audit() {
      this.$confirm(
        this.$l('tips_approved') || '是否要审核通过该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        },
      ).then(async () => {
        this.loadingOpen()
        this.$api
          .fabricInspectionAuditApi({ inspectionCode: this.inspectionCode })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('tips_submit_ok') || '审核成功！',
              type: 'success',
            })
            this.close()
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('tips_submit_no') || '审核失败！')
          })
      })
    },
    async reject() {
      this.$confirm(
        this.$l('tips_reject') || '是否要驳回该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        },
      ).then(async () => {
        this.loadingOpen()
        this.$api
          .fabricInspectionRejectApi({ inspectionCode: this.inspectionCode })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('tips_reject_ok') || '驳回成功！',
              type: 'success',
            })
            this.close()
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('tips_reject_no') || '驳回失败！')
          })
      })
    },
    async validateAndSaveForSubmit({ stop = false } = {}) {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      this.loadingOpen()
      const res = await this.$api
        .fabricInspectionSaveApi({ ...this.formData, validation: 'Y', stop })
        .catch(() => null)
      this.loadingClose()

      if (!res) return false
      const { status, msg } = res
      if (status != 200) {
        this.$message.error(msg)
        return false
      }
      await this.getData()
      return true
    },
    async saveSubmit() {
      const res = await this.validateAndSaveForSubmit()
      if (!res) return

      const { inspectionResult, v_inspectionResult } = this.formData
      if (inspectionResult === 'Y') {
        this.$confirm(
          `<p>本次面料检验报告判定结果为【${v_inspectionResult}】</p><p>是否正式提交面料检验报告？</p>`,
          '提交确认',
          {
            confirmButtonText: this.$l('INDEX.btn_confirm') || '确认',
            cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
            type: 'warning',
            dangerouslyUseHTMLString: true,
            closeOnClickModal: false,
            distinguishCancelAndClose: true,
          },
        ).then(async () => {
          await this.submitApi({
            submitType: 'submit',
          })
        })
        return
      }
      this.reviewOpts = { isStop: false }
      this.showReview = true
    },
    async openStopReview() {
      const res = await this.validateAndSaveForSubmit({ stop: true })
      if (!res) return
      this.reviewOpts = { isStop: true }
      this.showReview = true
    },
    async submitApi({ submitType, data, concessionList }) {
      if (this.loadingOpen()) return
      const res = await this.$api
        .fabricInspectionSubmitApi({
          submitType,
          ...data,
          concessionList,
          inspectionCode: this.inspectionCode,
        })
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_operate_no') || '操作失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
        type: 'success',
      })
      this.close()
    },

    close() {
      this.$emit('close')
    },
    async refresh() {
      await this.getData()
      await this.getInspectionDetailList()
    },
    async refreshDetail() {
      await this.getData()
      await this.getInspectionDetailList()
      this.$emit('updatePageCode')
    },

    sumKey(list, key) {
      if (!Array.isArray(list)) return 0
      return list.reduce((sum, item) => add(sum, Number(item?.[key]) || 0), 0)
    },
    openChooseFabric() {
      this.chooseMaterialVisible = true
    },
    chooseMaterialConfirm(data) {
      this.chooseMaterialVisible = false

      const {
        purchaseFabricCode,
        purchaseFabricDetailCode,
        fabricNo,
        fabricName,
        fabricWidth,
        fabricWidthUnit,
        fabricWeight,
        fabricWeightUnit,
        fabricColor,
        fabricContent,
        series,
        purchaseFabricNo,
        buyerName,
        scmName,
        purchaserEntityName,
        originOrderNo,
      } = data

      this.formData.v_fabricWidth = [fabricWidth, fabricWidthUnit]
        .filter(Boolean)
        .join(' ')
      this.formData.v_fabricWeight = [fabricWeight, fabricWeightUnit]
        .filter(Boolean)
        .join(' ')
      this.formData = {
        ...this.formData,
        purchaseFabricCode,
        purchaseFabricDetailCode,
        fabricNo,
        fabricName,
        fabricWidth,
        fabricWidthUnit,
        fabricWeight,
        fabricWeightUnit,
        fabricColor,
        fabricContent,
        series,
        purchaseFabricNo,
        buyerName,
        scmName,
        purchaserEntityName,
        originOrderNo,
      }
    },
    chooseUserConfirm(data) {
      const userList = data
        ? data.map((item) => {
            const { userNo, userName } = item
            return userNo ? `${userName}（${userNo}）` : userName
          })
        : []
      this.formData.reporterNames = [...new Set(userList || [])].join('、')
      this.formData = {
        ...this.formData,
        reporterList: [...data],
      }
    },
    choosewhConfirm(data) {
      const userList = data
        ? data.map((item) => {
            const { userNo, userName } = item
            return userNo ? `${userName}（${userNo}）` : userName
          })
        : []
      this.formData.whReceiverNames = [...new Set(userList || [])].join('、')
      this.formData = {
        ...this.formData,
        whReceiverList: [...data],
      }
    },
    arrivalDate() {
      return {
        disabledDate(time) {
          return new Date().getTime() < time.getTime()
        },
      }
    },
    inspectionDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.formData.arrivalDate) {
            return (
              new Date(self.formData.arrivalDate).getTime() - 3600 * 1000 * 24 >
                time.getTime() || new Date().getTime() < time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .status-tag {
  font-size: 12px;
  .el-tag--N {
    color: #101010;
    background-color: #f4f4f5;
    border: 1px solid #91939a;
  }
  .el-tag--Q {
    color: #e6a23c;
    background-color: #ffffff;
    border: 1px solid #f5dab1;
  }
  .el-tag--S {
    color: #70ce46;
    background-color: #e3f7d0;
    border: 1px solid #b7eb8f;
  }

  .el-tag--R {
    color: #007bff;
    background-color: #e9f3ff;
  }
  .el-tag--T {
    color: #f74852;
    background-color: #ffffff;
    border: 1px solid #f74852;
  }
  .el-tag--D {
    color: #f74852;
    background-color: #fff1f0;
    border: 1px solid #ffa39e;
  }
}
</style>
